import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner, faRotateRight } from '@fortawesome/free-solid-svg-icons';
import { Button } from '@/components/ui/button';

interface BulkImportProcessingStageProps {
  timedOut: boolean;
  onManualRefresh: () => void;
  isRefreshing: boolean;
  title?: string;
  description?: string;
}

export function BulkImportProcessingStage({
  timedOut,
  onManualRefresh,
  isRefreshing,
  title = 'Validating Workbook',
  description = 'Rows are being parsed, matched, and classified. This page updates automatically.',
}: BulkImportProcessingStageProps) {
  return (
    <div className="max-w-2xl space-y-4 rounded-lg border border-border bg-card p-8 text-center">
      <FontAwesomeIcon
        icon={faSpinner}
        className="mx-auto h-8 w-8 animate-spin text-primary"
        aria-hidden="true"
      />
      <div>
        <h2 className="text-sm font-semibold text-foreground">{title}</h2>
        <p className="mt-1 text-sm text-muted-foreground">{description}</p>
      </div>
      {timedOut && (
        <div className="space-y-2 rounded-lg border border-amber-500/30 bg-amber-500/10 px-4 py-3 text-left">
          <p className="text-xs text-amber-800">
            This is taking longer than expected. Validation may still be running in the background —
            you can check again manually.
          </p>
          <Button variant="secondary" size="sm" onClick={onManualRefresh} disabled={isRefreshing}>
            <FontAwesomeIcon
              icon={faRotateRight}
              className={`mr-2 h-3 w-3 ${isRefreshing ? 'animate-spin' : ''}`}
            />
            Check Status
          </Button>
        </div>
      )}
    </div>
  );
}
